import PropTypes from "prop-types";
import Card from "@mui/material/Card";
import Divider from "@mui/material/Divider";
import Icon from "@mui/material/Icon";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import { Button } from "rsuite";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import CountUp from "react-countup"; // Import CountUp for animation

function ComplexStatisticsCard({
  color,
  title,
  count,
  percentage,
  icon,
  loading,
  refresh,
  isAmount,
}) {

  const randomColorOptions = ["primary", "secondary", "info", "success", "warning", "error", "dark", "light"];
  const getRandomColor = () => randomColorOptions[Math.floor(Math.random() * randomColorOptions.length)];
  const randomColor = getRandomColor();

  return (
    <Card sx={{ minHeight: "170px" }}>
      <MDBox display="flex" justifyContent="space-between" pt={1} px={2}>
        <MDBox
          variant="gradient"
          bgColor={color}
          color={color === "light" ? "dark" : "white"}
          coloredShadow={color}
          borderRadius="xl"
          display="flex"
          justifyContent="center"
          alignItems="center"
          width="4rem"
          height="4rem"
          mt={-3}
          onClick={refresh}
        >
          <Button
            appearance="subtle"
            style={{
              color: "inherit",
              backgroundColor: "transparent",
              boxShadow: "none",
            }}
            onClick={refresh}
            disabled={!refresh}
          >
            <Icon fontSize="medium" color="inherit">
              {icon}
            </Icon>
          </Button>
        </MDBox>
        <MDBox textAlign="right" lineHeight={1.25}>
          <MDTypography variant="button" fontWeight="light" color="text">
            {title}
          </MDTypography>
          <MDTypography variant="h4">
            {isAmount && "$"}
            <CountUp
              decimals={isAmount?2:0}
              start={0} // Animation starts from 0
              end={count} // The final count value
              duration={1.5} // Duration of the animation in seconds
              separator="," // Adds comma separator for large numbers
            />
          </MDTypography>
        </MDBox>
      </MDBox>
      {percentage.label && <Divider />}
      <MDBox pb={2} px={2}>
        <MDTypography component="p" variant="button" color="text">
          <MDTypography
            component="span"
            variant="button"
            fontWeight="regular"
            color={percentage.color}
          >
            {percentage.icon === "up" ? (
              <ArrowUpwardIcon
                fontSize="small"
                sx={{
                  mr: 0.5,
                  color: percentage.color,
                  verticalAlign: "middle",
                }}
              />
            ) : percentage.icon === "down" ? (
              <ArrowDownwardIcon
                fontSize="small"
                sx={{
                  mr: 0.5,
                  color: percentage.color,
                  verticalAlign: "middle",
                }}
              />
            ) : null}

            {percentage.amount}
          </MDTypography>
          &nbsp;{percentage.label}
        </MDTypography>
      </MDBox>
    </Card>
  );
}

// Default props
ComplexStatisticsCard.defaultProps = {
  color: "info",
  percentage: {
    color: "success",
    text: "",
    label: "",
  },
};

// Prop Types
ComplexStatisticsCard.propTypes = {
  color: PropTypes.oneOf([
    "primary",
    "secondary",
    "info",
    "success",
    "warning",
    "error",
    "light",
    "dark",
  ]),
  title: PropTypes.string.isRequired,
  count: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  percentage: PropTypes.shape({
    color: PropTypes.oneOf([
      "primary",
      "secondary",
      "info",
      "success",
      "warning",
      "error",
      "dark",
      "white",
    ]),
    amount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    label: PropTypes.string,
  }),
  icon: PropTypes.node.isRequired,
};

export default ComplexStatisticsCard;
